@if (!hidden) {
  <mat-form-field
    [color]="color"
    [appearance]="appearance"
    [floatLabel]="floatLabel"
    [subscriptSizing]="hideSubscriptWrapper ? 'dynamic' : 'fixed'">
    @if (floatLabel === 'always') {
      <mat-label>{{label}}</mat-label>
    }
    <mat-select
      [multiple]="multiple"
      [formControl]="control"
      [compareWith]="compareById"
      [required]="required"
      [placeholder]="placeholder"
      panelClass="filter-select-panel filter-select-panel--search"
      [matTooltip]="tooltip()"
      [matTooltipClass]="'field-tooltip'"
      [matTooltipPosition]="toolTipPosition"
      (closed)="onClosed()">
      @if (multiple) {
        <mat-select-trigger>{{ summary() }}</mat-select-trigger>
      }

      <mat-option>
        <ngx-mat-select-search
          placeholderLabel="Search"
          noEntriesFoundLabel="No Payers Found"
          [id]="'filter-' + controlName"
          [formControl]="filterControl"
          [showToggleAllCheckbox]="multiple && selectAllEnabled"
          [toggleAllCheckboxChecked]="allToggled()"
          [toggleAllCheckboxIndeterminate]="indeterminate()"
          (toggleAll)="onToggleAll($event)"></ngx-mat-select-search>
      </mat-option>

      @for (option of filteredOptions; track option.ID) {
        <mat-option
          [value]="option"
          [matTooltip]="option.Name"
          [matTooltipClass]="'field-tooltip'"
          [matTooltipPosition]="'left'">
          {{option.Abbreviation}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}
